if (!customElements.get('collections-spotlight')) {
  customElements.define(
    'collections-spotlight',
    class CollectionsSpotlight extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.section = this.closest('[data-section-type="collections-spotlight"]');

        const allEvents = ['mouseenter', 'touchstart', 'focus', 'click'];

        this.querySelectorAll('[data-hover-target]')?.forEach((button) => {
          allEvents.forEach((event) => button.addEventListener(event, this.handleHover.bind(this)));
        });

        const selected = this.querySelector('[data-hover-target].is-selected');
        if (selected) {
          this.updateBgColor(selected.closest('[data-bg]'));
        }
      }

      handleHover(e) {
        const target = e.currentTarget;
        const isClickEvent = ['click', 'touchstart'].includes(e.type);

        if (isClickEvent && window.theme.isMobile()) {
          e.preventDefault();
        }

        this.updateBgColor(target.closest('[data-bg]'));
        this.updateState(target);
      }

      updateBgColor(element) {
        const color = element?.dataset.bg;
        const isValidColor = color && !['#00000000', 'rgba(0,0,0,0)', 'transparent'].includes(color);

        if (isValidColor) {
          this.section.style.setProperty('--bg', color);
        } else {
          this.section.style.removeProperty('--bg');
        }
      }

      updateState(target) {
        const targetId = target.dataset.hoverTarget;
        const newImage = this.querySelector(`#${targetId}`);
        const oldButtons = this.querySelectorAll('[data-hover-target]');
        const oldImages = this.querySelectorAll('[data-collection-image]');

        if (!newImage) return;

        oldImages.forEach((oldImage) => oldImage.classList.remove('is-visible'));
        oldButtons.forEach((oldButton) => oldButton.classList.remove('is-selected'));

        newImage.classList.add('is-visible');
        target.classList.add('is-selected');
      }
    }
  );
}
